module.exports = __webpack_public_path__ + "img/maintop.2bcf2b6.png";